/**
 * @generated SignedSource<<60794b2482bf6e4ecc6f98592590205b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AcknowledgeClientAssetInput = {
  projectId: string;
  assetId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type clientAssetMutationsAcknowledgeMutation$variables = {
  input: AcknowledgeClientAssetInput;
};
export type clientAssetMutationsAcknowledgeMutation$data = {
  readonly acknowledgeClientAsset: {
    readonly asset: {
      readonly id: string;
      readonly status: string;
    } | null;
  } | null;
};
export type clientAssetMutationsAcknowledgeMutation = {
  variables: clientAssetMutationsAcknowledgeMutation$variables;
  response: clientAssetMutationsAcknowledgeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AcknowledgeClientAssetPayload",
    "kind": "LinkedField",
    "name": "acknowledgeClientAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientAsset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "clientAssetMutationsAcknowledgeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "clientAssetMutationsAcknowledgeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "026320c79b1444aa738499d380f83fe5",
    "id": null,
    "metadata": {},
    "name": "clientAssetMutationsAcknowledgeMutation",
    "operationKind": "mutation",
    "text": "mutation clientAssetMutationsAcknowledgeMutation(\n  $input: AcknowledgeClientAssetInput!\n) {\n  acknowledgeClientAsset(input: $input) {\n    asset {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "afe0e4556118baff167a5c39c790f107";

export default node;
